/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.3.0-nightly.2026.5.23",
    versionName: "0.3.0-nightly.2026.5.23",
    versionChannel: "nightly",
    buildDate: "2026-05-23T00:33:34.002Z",
    commitHash: "e18e98be1ec3dd434046e2e1f6a6463942d2c16d",
};
